<div class="row">
	<div class="col-lg-4">
		<app-regime-list [regimes]="regimeCounts" (evaluateChange)="regimesChange()"></app-regime-list>
	</div><!-- End left column -->
	<div class="col-lg-8">
		<div class="panel">
			<div class="heading">Track Split</div>
			<div class="content">
				<app-dvs-chart [options]="timelineOptions" [height]="'300px'" [error]="(regimeCounts && regimeCounts.length === 0) ? 'No track data found' : undefined"
					[timezone]="fleet ? fleet.time_offset_hours : 0"></app-dvs-chart>
				@if (timelineOptions && adjustments && adjustments.length) {
					<div class="chart-legend">
						<span class="legend-item">
							<span class="swatch adjustment"></span> Adjustment (see below)
						</span>
					</div>
				}
			</div>
		</div>
	</div>
</div>
<app-adjustment-history [asset]="asset" [rotor]="rotor" [adjustments]="adjustments" (adjustmentDeleted)="updateAdjustments(); regimesChange();"></app-adjustment-history>